var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_3222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_3222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.52 12.2725C23.52 11.4216 23.4437 10.6034 23.3018 9.81787H12V14.4597H18.4582C18.18 15.9597 17.3346 17.2306 16.0637 18.0815V21.0925H19.9418C22.2109 19.0034 23.52 15.927 23.52 12.2725Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 23.9998C15.2398 23.9998 17.9561 22.9252 19.9416 21.0925L16.0635 18.0816C14.9889 18.8016 13.6143 19.227 11.9998 19.227C8.87428 19.227 6.22888 17.1161 5.2852 14.2798H1.27612V17.3889C3.25072 21.3107 7.30888 23.9998 11.9998 23.9998Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2854 14.2804C5.0454 13.5604 4.90908 12.7913 4.90908 12.0004C4.90908 11.2095 5.0454 10.4404 5.2854 9.72041V6.61133H1.27632C0.463681 8.23133 0 10.0641 0 12.0004C0 13.9367 0.463681 15.7695 1.27632 17.3895L5.2854 14.2804Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 4.77276C13.7616 4.77276 15.3434 5.37816 16.587 6.56724L20.0289 3.1254C17.9507 1.18908 15.2343 0 11.9998 0C7.30888 0 3.25072 2.68908 1.27612 6.61092L5.2852 9.72C6.22888 6.88368 8.87428 4.77276 11.9998 4.77276Z",
    fill: "#E94235"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.de45e986f350d05059496b860981b502.svg";
export { ForwardRef as ReactComponent };